import React from 'react';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import { withStyles } from '@material-ui/core/styles';
import useToggle from 'hooks/useToggle';
import moment from 'moment';
import { Grid } from '@material-ui/core';
import {
  OutlinedButton,
  SearchInput,
  Input as FormInput,
} from '@ds/react-components';
import { ReactComponent as FilterIcon } from 'assets/icons/fa-filter.svg';

const styles = (theme) => ({
  startAdornmentContainer: {
    backgroundColor: theme.palette.xpl.foreground,
    color: theme.palette.xpl.text.action,
  },
  filterIcon: {
    width: '15px',
    height: '15px',
    marginRight: '6px',
  },
  dobGrid: {
    maxWidth: 250,
  },
});

const SearchFields = (props) => {
  const { classes, dateFormat, onSubmit } = props;

  const [showDob, toggleShowDob] = useToggle(false);

  const { handleSubmit, control, errors, register } = useForm({
    defaultValues: {
      search: '',
      dob: null,
    },
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  return (
    <form name="searchForm" onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item lg={5} md={6} xs={12}>
          <SearchInput
            name={'search'}
            inputRef={register}
            placeholder={
              'Enter Name, Phone, Email or Debitsuccess ID or Business ID'
            }
            adornment={<SearchInput.SearchIconButton type={'submit'} />}
          />
        </Grid>
        <Grid item>
          <OutlinedButton
            variant="secondary"
            type={'button'}
            onClick={toggleShowDob}>
            <FilterIcon className={classes.filterIcon} />
            Filter By
          </OutlinedButton>
        </Grid>
        {showDob && (
          <Grid item lg={5} md={4} xs={10} className={classes.dobGrid}>
            <Controller
              name={'dob'}
              control={control}
              rules={{
                required: false,
                validate: (value) => {
                  if (!value) return true;
                  const momentDate = moment(value, dateFormat, true);
                  return (
                    (momentDate.isValid() &&
                      momentDate.isSameOrBefore(new Date())) ||
                    `Please enter a valid date (${props.dateFormat}).`
                  );
                },
              }}
              render={({ onChange, name, value, onBlur }) => (
                <FormInput
                  name={name}
                  mask="11/11/1111"
                  startAdornment={'Date of birth'}
                  showInlineIcons={true}
                  classes={{
                    startAdornmentContainer: classes.startAdornmentContainer,
                  }}
                  onBlur={onBlur}
                  placeholder={dateFormat}
                  value={value}
                  onChange={(event) => onChange(event.target.value)}
                  error={errors.dob && errors.dob.message}
                  aria-label="Enter optional date of birth"
                />
              )}
            />
          </Grid>
        )}
      </Grid>
    </form>
  );
};

SearchFields.propTypes = {
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  dateFormat: PropTypes.string,
};

export default withStyles(styles, { withTheme: true })(SearchFields);
